(function(root) {
  'use strict';
  // Reeis online-shopping sizing chart, verified October 1, 2026.
  const sizingChart = [
    { size:'1.5/2', capacity:'1.5/2 Ton', area:'500–800', min:500, max:800 },
    { size:'2.5', capacity:'2.5 Tons', area:'801–1,000', min:801, max:1000 },
    { size:'3', capacity:'3 Tons', area:'1,001–1,300', min:1001, max:1300 },
    { size:'3.5', capacity:'3.5 Tons', area:'1,301–1,500', min:1301, max:1500 },
    { size:'4', capacity:'4 Tons', area:'1,501–1,800', min:1501, max:1800 },
    { size:'5', capacity:'5 Tons', area:'1,801–2,200', min:1801, max:2200 }
  ];
  const options = {
    unit: [ ['split','Indoor + outdoor equipment'], ['package','One all-in-one unit'], ['unknown','I’m not sure'] ],
    currentHeat: [ ['electric','Electric heat pump'], ['gas','Gas furnace'], ['unknown','I’m not sure'] ],
    size: [...sizingChart.map(({size,area,capacity})=>[size,`${area} sq ft · ${capacity}`]), ['unknown','Not sure / area not listed']]
  };
  const labels = { unit: 'Equipment setup', currentHeat: 'Current heating', size: 'Select unit capacity' };
  function steps() { return ['unit','currentHeat','size']; }
  function valid(field,value) { return (options[field]||[]).some(([id])=>id===value); }
  function answered(s,field) { return valid(field,s[field]); }
  function complete(s) { return steps(s).every(field=>answered(s,field)); }
  function heating(s) { return ['electric','gas'].includes(s.currentHeat) ? s.currentHeat : 'unknown'; }
  function apply(s,field,value) {
    if(!valid(field,value)) return s;
    const next={...s,[field]:value,system:null};
    next.heat=heating(next);
    return next;
  }
  function label(s,field) { return (options[field]||[]).find(([id])=>id===s[field])?.[1] || 'Not answered yet'; }
  function result(s) {
    const heat=heating(s);
    const callOffice=s.unit==='package'&&heat==='gas';
    const review=[];
    if(!['split','package'].includes(s.unit)) review.push('Identify your equipment setup');
    if(!['electric','gas'].includes(heat)) review.push('Confirm the right heating option');
    if(!valid('size',s.size)||s.size==='unknown') review.push('Confirm equipment capacity with a home assessment');
    const family=s.unit==='split'?(heat==='electric'?'Split heat pump system':heat==='gas'?'Split A/C + gas furnace':'Split system · heating to confirm'):s.unit==='package'?(heat==='electric'?'Packaged heat pump':heat==='gas'?'Packaged gas / electric system':'Packaged system · heating to confirm'):'Equipment identification';
    return { heat, title:family, review, callOffice, ready:complete(s)&&review.length===0&&!callOffice };
  }
  const api={sizingChart,options,labels,steps,valid,answered,complete,heating,apply,label,result};
  if(typeof module!=='undefined') module.exports=api; else root.ReeisFinder=api;
})(typeof window!=='undefined'?window:globalThis);
